/**
 * One source of brand truth.
 *
 * UIKit deliberately ships no <Logo>, no <Header> and no <Footer> — product
 * identity is the one thing a component library cannot get right for you.
 * It lives here instead, so there is exactly one place to change it.
 *
 * The theme id must match the class in `styles/brand.css`.
 */
export const brand = {
  /** Theme id — matches `.theme-voila-latest` in styles/brand.css. */
  themeId: 'voila-latest',

  name: 'Voilacode',
  legalName: 'Voilacode Technologies',
  tagline: 'Your engineering partner for the AI era.',

  /** Shown in the shell and the browser tab. */
  shortName: 'Voilacode',

  email: 'founder@voilacode.com',
  address: 'Hitech City, Hyderabad — 500081',

  /** Primary navigation. */
  nav: [
    { label: 'Services', to: '/services' },
    { label: 'Work', to: '/work' },
    { label: 'About', to: '/about' },
    { label: 'Contact', to: '/contact' },
  ] as { label: string; to: string }[],

  /** The small-print row at the bottom of the footer. */
  legal: [
    { label: 'Privacy', to: '/privacy' },
    { label: 'Terms', to: '/terms' },
    { label: 'Refunds', to: '/refund' },
    { label: 'Cancellation', to: '/cancellation' },
  ] as { label: string; to: string }[],

  /** Assurances listed in the footer. */
  trust: ['GDPR-aligned', 'NDA-ready', 'DPA on request', 'IP assigned at delivery', 'Open-source'],
} as const;

export type BrandNavItem = (typeof brand.nav)[number];
